import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bool, any, string } from 'prop-types';
import { push } from 'connected-react-router';
import { mapUserFormValues } from '@widergy/utilitygo-forms-web';

import { ROUTES } from 'constants/routes';
import { accountPropTypes } from 'redux/accountHandlers';
import { actionCreators as customProceduresActions } from 'redux/customProceduresHandlers';
import { actionCreators as paymentActions } from 'redux/paymentHandlers';
import { gaTrackPageView } from 'services/AnalyticsService';
import { message } from 'utils/stringUtils';

import { getTotalAmount, getPayableBills } from './registerAccountHelper';
import RegisterAccount from './layout';
import { formatedAccount } from './utils';
import styles from './styles';
import RegisterAccountHistory from './components/RegisterAccountHistory/layout';
import { registerAccountFields } from './constants';

class RegisterAccountContainer extends Component {
  componentDidMount() {
    gaTrackPageView(ROUTES.NEW_ACCOUNT_HOLDER_CHANGE);
  }

  componentWillUnmount() {
    this.props.dispatch(customProceduresActions.cleanAccountData());
  }

  getInitialValues = () => {
    const fieldId = registerAccountFields.filter(item => item.key === 'address')[0];
    return {
      accountNumber: this.props.tempClientNumber,
      [`id${fieldId && fieldId.id}`]: this.props.address
    };
  };

  getPayableBills = () =>
    getPayableBills(
      this.props.accountTotalDebt &&
        this.props.accountTotalDebt.Recibos && [
          ...(this.props.accountTotalDebt.Recibos || []),
          ...((this.props.accountDueDebt && this.props.accountDueDebt.Recibos) || [])
        ]
    );

  getSupplyPayableBills = () =>
    getPayableBills(
      this.props.customProcedureData &&
        JSON.parse(this.props.customProcedureData.CONTENIDO) && [
          ...(JSON.parse(this.props.customProcedureData.CONTENIDO).RecibosSuministro || []),
          ...(JSON.parse(this.props.customProcedureData.CONTENIDO).RecibosCliente || [])
        ]
    );

  handleSubmit = response => {
    const newFields = mapUserFormValues(registerAccountFields, response);
    return this.props.shouldShowRegisterAccountForm
      ? this.props.dispatch(
          customProceduresActions.createNewService({
            ...newFields,
            accountNumber: this.props.tempClientNumber,
            address: this.props.address,
            warrantyCharge: this.props.warrantyCharge
          })
        )
      : this.props.dispatch(
          customProceduresActions.evaluateCreateNewService(
            response.accountNumber || response.accountNumberSelect
          )
        );
  };

  handleOnProcedureCancel = () => {
    this.props.dispatch(
      customProceduresActions.cancelCustomProcedure(
        this.props.customProcedureData && this.props.customProcedureData.Id,
        this.props.customProcedureData
      )
    );
  };

  handleAccountPayment = clientNumber => {
    const totalAmount =
      (this.props.shouldShowAccountHolderHistory &&
        this.props.customProcedureData &&
        this.props.customProcedureData.CONTENIDO &&
        JSON.parse(this.props.customProcedureData.CONTENIDO).DeudaConsolidadaSuministro +
          JSON.parse(this.props.customProcedureData.CONTENIDO).DeudaCliente) ||
      getTotalAmount(this.props.accountTotalDebt, this.props.accountDueDebt);
    const amountList =
      this.props.shouldShowAccountHolderHistory && (this.getPayableBills() || this.getSupplyPayableBills());
    this.props.dispatch(
      paymentActions.paymentFlowInit(
        totalAmount,
        amountList,
        this.props.customProcedureData && this.props.customProcedureData.Id,
        message(`RegisterAccount:finishedProcedureWithNIS`, {
          clientNumber: formatedAccount(clientNumber, this.props.accountList)
        })
      )
    );
  };

  handleGoToDashboard = () => this.props.dispatch(push(ROUTES.ACCOUNT_STATUS));

  render() {
    // TODO: What happens with account due debt?
    return (
      <Fragment>
        <div style={styles.holderChangeContainer}>
          {this.props.shouldShowAccountHolderHistory ? (
            <RegisterAccountHistory
              onProcedureCancel={this.handleOnProcedureCancel}
              onPayment={this.handleAccountPayment}
              onGoToDashboard={this.handleGoToDashboard}
              processHistory={this.props.customProcedureData}
              loading={this.props.loading}
              formType="Alta de suministro"
              clientNumber={
                this.props.customProcedureData &&
                this.props.customProcedureData.CONTENIDO &&
                JSON.parse(this.props.customProcedureData.CONTENIDO).NIS
              }
              accountList={this.props.accountList}
              bills={this.props.customProcedureData && JSON.parse(this.props.customProcedureData.CONTENIDO)}
              currentAccountHolderName={this.props.currentAccountHolderName}
              accountTotalDebt={
                this.props.customProcedureData &&
                this.props.customProcedureData.CONTENIDO &&
                JSON.parse(this.props.customProcedureData.CONTENIDO).DeudaConsolidadaSuministro
              }
              accountDueDebt={
                this.props.customProcedureData &&
                this.props.customProcedureData.CONTENIDO &&
                JSON.parse(this.props.customProcedureData.CONTENIDO).DeudaCliente
              }
              showOnlyHistory={
                this.props.customProcedureData &&
                this.props.customProcedureData.ProcessActivity &&
                this.props.customProcedureData.ProcessActivity.State &&
                this.props.customProcedureData.ProcessActivity.State.Name === 'PendienteOpenSGC'
              }
            />
          ) : (
            <RegisterAccount
              onSubmit={this.handleSubmit}
              shouldShowRegisterAccountForm={this.props.shouldShowRegisterAccountForm}
              loading={this.props.loading}
              accountTotalDebt={this.props.accountTotalDebt}
              accountDueDebt={this.props.accountDueDebt}
              clientNumber={this.props.tempClientNumber}
              address={this.props.address}
              currentAccountHolderName={this.props.currentAccountHolderName}
              initialValues={this.getInitialValues()}
              warrantyCharge={this.props.warrantyCharge}
            />
          )}
        </div>
      </Fragment>
    );
  }
}

RegisterAccountContainer.propTypes = {
  shouldShowRegisterAccountForm: bool.isRequired,
  shouldShowAccountHolderHistory: bool.isRequired,
  loading: bool.isRequired,
  accountTotalDebt: any, // eslint-disable-line
  accountDueDebt: any, // eslint-disable-line
  tempClientNumber: string,
  address: string,
  currentAccountHolderName: string,
  customProcedureData: any, // eslint-disable-line
  warrantyCharge: string,
  accountList: accountPropTypes
};

const mapStateToProps = store => ({
  accountList: store.account.accounts,
  shouldShowRegisterAccountForm: store.customProcedures.shouldShowNewServiceForm,
  shouldShowAccountHolderHistory: store.customProcedures.shouldShowNewServiceHistory,
  loading: store.customProcedures.loading || store.payment.paymentRequestLoading,
  accountTotalDebt: store.customProcedures.accountTotalDebt,
  accountDueDebt: store.customProcedures.accountDueDebt,
  tempClientNumber: store.customProcedures.newServiceTempClientNumber,
  address: store.customProcedures.accountData && store.customProcedures.accountData.DIRECCION_1,
  cadastreP: store.customProcedures.accountData && store.customProcedures.accountData.NRO_CATASTRO,
  cadastrePP: store.customProcedures.accountData && store.customProcedures.accountData.NUM_PREPARTIDA,
  currentAccountHolderName: store.account.currentAccount && store.account.currentAccount.holder_name,
  customProcedureData: store.customProcedures.customProcedureData,
  warrantyCharge:
    store.customProcedures.accountData && store.customProcedures.accountData.PARAMETRO_DEPOSITO_GARANTIA
});

export default connect(mapStateToProps)(RegisterAccountContainer);
